"use strict";
exports.__esModule = true;
exports.TabsProvider = exports.Tabs = void 0;
var Tabs_1 = require("./Tabs");
var TabsButton_1 = require("./TabsButton");
var TabsContext_1 = require("./TabsContext");
exports.TabsProvider = TabsContext_1.TabsProvider;
var TabsList_1 = require("./TabsList");
var TabsPanel_1 = require("./TabsPanel");
var Tabs = Object.assign(Tabs_1.Tabs, {
    Button: TabsButton_1.TabsButton,
    List: TabsList_1.TabsList,
    Panel: TabsPanel_1.TabsPanel,
    Context: TabsContext_1.TabsContext
});
exports.Tabs = Tabs;
//# sourceMappingURL=index.js.map